import { formatDateUtil } from "@utils/date.util";
import { PRIMARY_KEY } from "@constants/app.constants";

const tableTitle = "Promo Code List";
const keyColumn = PRIMARY_KEY;
const menuUrl = "promo-code";
const tableColumn = [
  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "Name",
  },
  {
    id: "code",
    numeric: false,
    disablePadding: false,
    label: "Code",
  },
  {
    id: "code_value",
    numeric: false,
    disablePadding: false,
    label: "Value",
  },
  {
    id: "type",
    numeric: false,
    disablePadding: false,
    label: "Type",
    isBadge: true,
    primaryKey: keyColumn,
    badgeText: {
      1: "Fixed",
      2: "Percentage",
    },
    badgeColor: {
      1: "success",
      2: "danger",
    },
  },
  {
    id: "status",
    numeric: false,
    disablePadding: false,
    label: "Status",
    isBadge: true,
    primaryKey: keyColumn,
    badgeText: {
      1: "Active",
      0: "Inactive",
    },
    badgeColor: {
      1: "success",
      0: "danger",
    },
  },
  {
    id: "created_at",
    numeric: false,
    disablePadding: false,
    label: "Created At",
    formatData: formatDateUtil,
  },
];
const breadCrumbs = [{ name: "Promo Code", menu_url: "/promo-code" }];

const filters = [
  {
    name: "type",
    id: "type",
    label: "Type",
    value: "",
    type: "SELECT",
    options: [
      { name: "Fixed", value: "fixed" },
      { name: "Percentage", value: "percentage" },
    ],
    validations: [],
    isVertical: true,
    groupClass: "col-md-3",
  },

  {
    name: "status",
    id: "status",
    label: "Status",
    value: "",
    type: "SELECT",
    placeholder: "Select Status",
    options: [
      { name: "Active", value: "1" },
      { name: "Inactive", value: "0" },
    ],
    validations: [],
    isVertical: true,
    groupClass: "col-md-3",
  },
];

export {
  tableTitle,
  keyColumn,
  tableColumn,
  breadCrumbs,
  menuUrl,
  filters,
};
